<script setup>
import WizardProgress from "@/components/wizard/WizardProgress.vue";
import WizardProgressStep from "@/components/wizard/WizardProgressStep.vue";
import {GenderLabel, IsChildLabel, YesNoLabels} from "@/choices";
import {convertPriorityToColor, PriorityLabel} from "@/components/hpo/choices";
import {unitType} from "../utils";
import truncate from "lodash/truncate";
import {computed} from "vue";

const props = defineProps({
    wizard: {
        type: Object,
        required: true,
    },
    formData: {
        type: Object,
        required: true,
    }
});

const diagnosisShort = computed(() => {
    return truncate(props.formData.diagnose, {length: 15});
});
</script>

<template>
    <WizardProgress :wizard="wizard">
        <WizardProgressStep :label="pgettext('label', 'TIC')" step-name="tic" >
            {{ formData.ticPrefix }}{{ formData.ticNumber }}
        </WizardProgressStep>

        <WizardProgressStep :label="pgettext('label', 'Transport Priority')" step-name="transportPriority">
            <v-chip v-if="formData.transportPriority" density="compact" variant="flat" :ripple="false" :color="convertPriorityToColor(formData.transportPriority).toLowerCase()" rounded class="py-0 px-2">
                <strong>{{ PriorityLabel[formData.transportPriority] }}</strong>
            </v-chip>
        </WizardProgressStep>

        <WizardProgressStep :label="pgettext('label', 'Gender')" step-name="gender">
            {{ GenderLabel[formData.gender] }}
        </WizardProgressStep>
        <WizardProgressStep :label="pgettext('label', 'Age')" step-name="isChild">
            {{ IsChildLabel[formData.isChild] }}
        </WizardProgressStep>

        <WizardProgressStep :label="pgettext('label', 'Diagnosis')" step-name="diagnose">
            {{ diagnosisShort }}
        </WizardProgressStep>
        <WizardProgressStep :label="pgettext('label', 'ALS')" step-name="ventilated">
            {{ YesNoLabels[formData.ventilated] }}
        </WizardProgressStep>
        <WizardProgressStep :label="pgettext('label', 'Transport Unit')" step-name="unit">
            {{ unitType(formData.unitType, formData.unitTypeSpec) }} {{ formData.callSign }}
        </WizardProgressStep>
        <WizardProgressStep :label="pgettext('label', 'Hospital Type')" step-name="hospitalType">
            {{ formData.hospitalType }}
        </WizardProgressStep>

        <WizardProgressStep :label="pgettext('title', 'Summary')" step-name="summary" />
    </WizardProgress>
</template>
